import { Component, Input } from '@angular/core';
import { GlobalUtilsService } from 'src/app/global-utils.service';

@Component({
  selector: 'app-arrow-icon',
  template: `
    <div
      class="arrow"
      [ngClass]="{
        over: over,
        tablet: globalUtilsService.isTablet(),
        mobile: globalUtilsService.isMobile()
      }"
    >
      <span class="cable"></span>
      <span class="pointer"></span>
    </div>
  `,
  styles: [
    `
      .arrow {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .cable {
        display: block;
        background: #13A538;
        width: 0.24rem;
        height: 1px;
        transform-origin: center left;
        transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);
      }

      .pointer {
        display: block;
        position: relative;
        width: 0.2rem;
        height: 0.2rem;
        margin-left: -0.22rem;
        border-left: 1px solid #13A538;
        border-bottom: 1px solid #13A538;
        transform: rotate(-135deg);
        transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);
      }

      .arrow.over .cable {
        transform: scaleX(2);
        transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);
      }

      .arrow.over .pointer {
        transform: translateX(0.24rem) rotate(-135deg);
        transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);
      }

      .arrow.tablet .cable {
        width: 0.5rem;
      }

      .arrow.tablet .pointer {
        width: 0.4rem;
        height: 0.4rem;
        margin-left: -0.4rem;
      }

      .arrow.over.tablet .pointer {
        transform: translateX(0.46rem) rotate(-135deg);
      }

      .arrow.mobile .cable {
        width: 0.37rem;
      }

      .arrow.mobile .pointer {
        width: 0.28rem;
        height: 0.28rem;
        margin-left: -0.28rem;
      }

      .arrow.over.mobile .pointer {
        transform: translateX(0.38rem) rotate(-135deg);
      }
    `
  ]
})
export class ArrowIconComponent {
  @Input()
  over: boolean;

  constructor(public globalUtilsService: GlobalUtilsService) {
    this.over = false;
  }
}
